import React from "react";
import Typography from "@material-ui/core/Typography";
import Recaptcha from "react-recaptcha";

import { isRecaptchaTimeoutError } from "../../functions/recaptcha";

const RECAPTCHA_SITE_KEY = "6LfhXLgUAAAAAPg5DRz-NkEMV1dmMI8LEMOEsrrH";
const RECAPTCHA_EXPIRED_MESSAGE =
  "The reCAPTCHA check expired. Please click the checkbox again.";
const RECAPTCHA_TIMEOUT_MESSAGE =
  "The reCAPTCHA check timed out. Please click the checkbox again.";

const SignupRecaptcha = ({ classes, errorMessage, onChange, onError }) => {
  const recaptchaRef = React.useRef(null);

  const resetRecaptcha = React.useCallback(
    message => {
      onChange("");
      if (recaptchaRef.current && recaptchaRef.current.reset) {
        recaptchaRef.current.reset();
      }
      onError(message);
    },
    [onChange, onError]
  );

  React.useEffect(() => {
    const handleUnhandledRejection = event => {
      if (!isRecaptchaTimeoutError(event.reason)) {
        return;
      }

      event.preventDefault();
      resetRecaptcha(RECAPTCHA_TIMEOUT_MESSAGE);
    };

    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    return () => {
      window.removeEventListener(
        "unhandledrejection",
        handleUnhandledRejection
      );
    };
  }, [resetRecaptcha]);

  return (
    <div
      id="recaptcha"
      className={
        classes.recaptchabox +
        (errorMessage && classes.validationChoiceError
          ? " " + classes.validationChoiceError
          : "")
      }
      tabIndex="-1"
    >
      <Recaptcha
        ref={recaptchaRef}
        className={classes.recaptcha}
        type="checkbox"
        sitekey={RECAPTCHA_SITE_KEY}
        verifyCallback={response => {
          onError("");
          onChange(response);
        }}
        expiredCallback={() => {
          resetRecaptcha(RECAPTCHA_EXPIRED_MESSAGE);
        }}
      />
      {errorMessage ? (
        <Typography className={classes.validationInlineMessage}>
          {errorMessage}
        </Typography>
      ) : null}
    </div>
  );
};

export default SignupRecaptcha;
